// extracted by mini-css-extract-plugin
export default {"menu":"PickupAddressMapClusterMenu_menu__2Rh4_","title":"PickupAddressMapClusterMenu_title__303iY","pointTitle":"PickupAddressMapClusterMenu_pointTitle__CEM1Y"};